import { camelCase } from '../util.js'
export default {
  name: '启赋',
  logo: {
    default: camelCase('cases-brand-12'),
    active: camelCase('cases-brand-12-cover')
  },
  works: []
}
